module.exports = __webpack_public_path__ + "static/media/stockhausen_folkwang_2.bb0c2ab7.jpg";